//////////////////
// IMPORTS
//////////////////
// schema
import * as ISchema from "@schema";
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// team-picker imports
import { IContainer, IProps, IState } from "./TeamPicker.d";
import { styles } from "./TeamPicker.styles";
import { teamPickerFragments } from "./TeamPicker.gql";
// state
import { IReduxState } from "@reducers/root.reducer";
// material-ui
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

//////////////////
// COMPONENT
//////////////////
class TeamPickerCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      selectedTeamId: props.teamId,
    };
  }

  // ~-~-~-~-~-~-~-
  // Lifecycle
  // ~-~-~-~-~-~-~-
  public UNSAFE_componentWillReceiveProps(nextProps: IProps) {
    if (nextProps.teamId !== this.state.selectedTeamId) {
      this.setState({ selectedTeamId: nextProps.teamId });
    }
  }

  // ~-~-~-~-~-~-~-
  // Helpers;
  // ~-~-~-~-~-~-~-
  private onChange = (selectedTeamId: string) => {
    this.props.onChange(selectedTeamId);
    this.setState({ selectedTeamId });
  };

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  private renderMenuItem = (team: ISchema.ITeam) => {
    const { classes, primaryTeamId, hidePrimaryIndicator } = this.props;
    return (
      <MenuItem
        cw-id="team-in-teampicker"
        key={`team-select-${team.teamId}-${team.teamName}`}
        value={team.teamId}
      >
        <div className={classes.menuItemLabel}>
          {team.teamName}{" "}
          {team.teamId === primaryTeamId && !hidePrimaryIndicator ? "(primary)" : ""}
        </div>
      </MenuItem>
    );
  };

  public render() {
    const {
      userTeams,
      label,
      primaryTeamId,
      disabled,
      largeStyles,
      inlineStyles,
      hideLabel,
      disableUnderline,
      classes,
    } = this.props;
    const { selectedTeamId } = this.state;

    const sortedList = userTeams.list
      .map((a) => a)
      .sort((a, b) => {
        if (a.teamId === primaryTeamId) {
          return -1;
        } else if (b.teamId === primaryTeamId) {
          return 1;
        } else {
          return a.teamName.localeCompare(b.teamName);
        }
      });

    return (
      <FormControl className={this.props.classes.container} fullWidth>
        {!hideLabel ? (
          <InputLabel shrink htmlFor="cw-team-select">
            {label}
          </InputLabel>
        ) : (
          ""
        )}
        <Select
          value={selectedTeamId}
          onChange={(e) => this.onChange(e.target.value as string)}
          name="Team Picker"
          inputProps={{
            name: "Team Picker",
            id: "cw-team-select",
          }}
          MenuProps={{
            classes: {
              paper: this.props.classes.menuPaper,
            },
          }}
          fullWidth
          disabled={disabled}
          classes={{
            select: largeStyles
              ? classes.largeSelect
              : inlineStyles
              ? classes.inlineSelect
              : undefined,
          }}
          disableUnderline={disableUnderline}
        >
          {sortedList.map(this.renderMenuItem)}
        </Select>
      </FormControl>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
export const TeamPickerStyled = withStyles(styles)(TeamPickerCmpt);

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

const TeamPickerRedux = connect(mapStateToProps, {})(TeamPickerStyled);

//////////////////
// RELAY
//////////////////
export const TeamPicker = createFragmentContainer<IContainer>(TeamPickerRedux, teamPickerFragments);
